import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { CardView, TrainIcon } from '../../Style';
import { trainDetails, cityDetails, boardingDetails, preferences } from '../../config';
import { GenericP, FlexDiv, GenericDiv } from 'commonStyles';
import DropDown from 'common/Dropdown/DropDown';
import { InputBox } from 'common/FormField/formField';
import TrainCalender from './TrainCalender';
import { setTrainData } from '../../../redux/actions/trainActionDispatcher';
import { ConditionalWrapper } from 'UtilityComponents/Util';
import Grid from 'common/Grid/Grid';
import DisplayContext, { Devices } from 'UtilityComponents/displayContext';

function TrainForm() {
	const dispatch = useDispatch();
	const trainDetailsFormData = useSelector((state) => state.train.trainDetails || []);
	const displayName = useContext(DisplayContext).isMobile;

	const isMobile = displayName == Devices.mobile;

	const handleChange = (field) => (val) => {
		const formData = { ...trainDetailsFormData };
		formData[field.name] = val;
		dispatch(setTrainData(formData));
	};

	const renderFieldType = (type, field) => {
		switch (type) {
			case 'text':
				return <InputBox handleChange={handleChange(field)} key={field.name} field={field} />;
			case 'label':
				return (
					!isMobile &&
					<GenericP
						fsize='16px'
						f_weight='900'
						color='#4a4a4a'
						bottom_M={field.marginBottom ? field.marginBottom : 16}>
						{field.placeHolder}
						{field.isMandatory && <span style={{ color: '#ff6544', marginLeft: '2px' }}>*</span>}
					</GenericP>
				);
			case 'icon':
				return <TrainIcon icon={field.icon} />;
			case 'dropDown':
				return (
					<GenericDiv top_M={isMobile ? '0' : '-14'}>
						<DropDown
							borderLess={!isMobile}
							padding='10px 8px'
							f_Size='14px'
							field={field}
							placeholder={isMobile ? field.placeholder : undefined}
							handleChange={handleChange(field)}
						/>
					</GenericDiv>
				);
			case 'calender':
				return (
					<TrainCalender isMobile={isMobile} handleChange={handleChange(field)} />
				);
		}
	};

	const renderFieldCard = (cardData) => {
		const ele = [];
		for ( let card in cardData) {
			const cardItem = cardData[card];
			ele.push(renderFieldType(cardItem.inputType, cardItem));
		};
		return ele;
	};

	const renderFields = (field, width, height, noSpacing) =>(
		<ConditionalWrapper
			condition={!isMobile}
			wrapper={(children) => (
				<CardView radis='6px' boxMargin='0 0 10px' boxPadding='20px 30px' $width={width} height={height}>
					{children}
				</CardView>
			)}>
			<Grid container justify='space-between' spacing={noSpacing ? 0 : 3}>
				{field && field.map((field, index) => (
					!field.hideMobile &&
					<Grid item xs={field.xs} lg={field.lg} key={index} itemClass={field.itemClass}>
						{renderFieldCard(field)}
					</Grid>
				))}
			</Grid>
		</ConditionalWrapper>
	);

	const multiCardRow = (othersObj) => (
		<Grid container justify='space-between' spacing={3}>
			{othersObj && othersObj.map((obj, index) =>(
				<Grid key={index} item xs={12} lg={4}>
					{renderFields(obj, false, '120px', true)}
				</Grid>
			))}
		</Grid>
	);

	return (
		<>
			{renderFields(trainDetails)}
			{renderFields(cityDetails)}
			{renderFields(boardingDetails)}
			{multiCardRow(preferences)}
		</>
	);
}

export default TrainForm;
